import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import es from 'vuetify/es5/locale/es';
import en from 'vuetify/es5/locale/en';

import i18n from '../i18n';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: {
          base: '#E1052D',
          lighten1: '#F31B33',
          lighten2: '#FC4450',
          lighten3: '#F06C73',
          lighten4: '#F7969B',
          lighten5: '#FFCBD3',
          lighten6: '#FFEAEF',
        },
        secondary: '#FFCBD3',
        accent: '#052DE1',
        error: '#FF5252',
        info: '#2196F3',
        success: {
          darken2: '#00642C',
          darken1: '#00824B',
          base: '#4CAF50',
          lighten2: '#00B277',
          lighten3: '#00d09c',
          lighten4: '#92EDD5',
          lighten5: '#D4F8EF',
        },
        warning: '#FFC107',
        yellow: '#FBD45D',
        orange: '#FB9203',
        teal: '#7A91F8',
      },
    },
  },
  lang: {
    locales: { es, en },
    current: process.env.VUE_APP_I18N_LOCALE,
    t: (key, ...params) => i18n.t(key, params),
  },
  icons: {
    iconfont: 'md',
  },
});
